import { maskPhone } from './maskPhone';

export const COUNTRY_PREFIX = '+91';

const NATIONAL_LENGTH = 10;
const COUNTRY_DIGITS = '91';
const TRUNK_DIGIT = '0';
const GROUP_AT = 5;

export type ContactChannel = 'WHATSAPP' | 'SMS' | 'EMAIL';

export const nationalNumber = (raw: string): string | null => {
  const digits = raw.replace(/\D/g, '');
  if (digits.length === NATIONAL_LENGTH) return digits;
  if (digits.length === NATIONAL_LENGTH + COUNTRY_DIGITS.length && digits.startsWith(COUNTRY_DIGITS)) {
    return digits.slice(COUNTRY_DIGITS.length);
  }
  if (digits.length === NATIONAL_LENGTH + 1 && digits.startsWith(TRUNK_DIGIT)) return digits.slice(1);
  return null;
};

export const formatPhone = (raw: string): string => {
  const national = nationalNumber(raw);
  if (national === null) return raw.trim();
  return `${COUNTRY_PREFIX} ${national.slice(0, GROUP_AT)} ${national.slice(GROUP_AT)}`;
};

export const maskedPhone = (raw: string): string | null => {
  const masked = maskPhone(nationalNumber(raw) ?? raw);
  return masked === null ? null : `${COUNTRY_PREFIX} ${masked}`;
};

export const maskedTo = (sentOn: ContactChannel, masked: string): string => {
  const target = masked.trim();
  if (sentOn === 'EMAIL' || target.startsWith('+')) return target;
  return `${COUNTRY_PREFIX} ${target}`;
};
